module.exports = __webpack_public_path__ + "static/media/8S.ce87a89a.svg";